/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
// import Dropdown from '../dropdown_ml/Dropdown';
import styles from './TablePage.less?modules';
import ButtonML from '@/components/button_ml/ButtonML';
import { CONSTANT } from '../../constant/index';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import TableLinkML from '@/containers/data_table_ml/table_link_ml/TableLinkML';

const TablePage = (props) => {
  const deleteTrigger = useTrigger();

  const { loadingstatus, edit } = props || {};
  const handleMemberDelete = (record) => {
    props.deleteItem(record);
  };
  const menuClick = (a, b) => {
    props.menuClick(a, b);
  };

  const goToModal = (e) => {
    props.goToModal(e);
  };

  const uploadAction = (e) => {
    props.uploadAction(e);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 40,
    },
    {
      title: '模型编号',
      dataIndex: 'modelNo',
      key: 'modelNo',
      width: 80,
    },
    {
      title: '模型名称',
      dataIndex: 'modelName',
      key: 'modelName',
      width: 140,
      render: (recor, item) => {
        return <TableLinkML text={recor} handleClick={() => goToModal(item)} />;
      },
    },
    {
      title: '输出',
      dataIndex: 'outputIndex',
      key: 'outputIndex',
      width: 100,
    },
    {
      title: '模型描述',
      dataIndex: 'description',
      key: 'description',
      width: 100,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 100,
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
    },
    {
      title: '模型状态',
      dataIndex: 'modelStatus',
      key: 'modelStatus',
      width: 60,
      render: (recor) => {
        const result = CONSTANT.statusList.find((item) => item.value === recor);
        if (result) {
          return result.value ? result.name : '';
        }
        return recor;
      },
    },

    {
      title: '操作',
      width: 180,
      render: (recor) => {
        // recor.editable = false;
        return (
          <div className={styles.handle_btn}>
            <ButtonML
              size="large"
              value="编辑"
              onClick={() => edit(recor)}
              disabled={String(recor.editable) === 'false'}
            />
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => handleMemberDelete(recor)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              icon={<ExclamationCircleOutlined />}
              disabled={String(recor.editable) === 'false'}
            />
            {/* <Dropdown
              size="large"
              title="其他操作"
              fontsize="14px"
              item={recor}
              menuClick={menuClick}
              uploadAction={uploadAction}
              disabled={recor.String(editable) === 'false'}
            /> */}
            <ButtonML
              size="large"
              value="操作记录"
              onClick={() => menuClick('3', recor)}
            />
          </div>
        );
      },
    },
  ];
  return (
    <>
      <DataTable
        className="demo-test"
        // style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={false}
        // pagination={pagination}
        scroll={{ x: 1547, y: 'calc(100vh - 156px - 3rem)' }}
        loading={loadingstatus}
        dataSource={props.tableData}
        changePage={(a) => {
          props.pageNumChange(a);
        }}
        changePageSize={(a) => {
          props.pageSizeChange(a);
        }}
      />
    </>
  );
};
export default TablePage;
